import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CertService } from '../../services/cert.service';
import { SearchEdictResponse } from '../../models/search-edict-response.model';

@Component({
  selector: 'app-cert-index',
  templateUrl: './cert-index.component.html',
  styleUrls: ['./cert-index.component.scss']
})
export class CertIndexComponent {
  searchForm = this.fb.group({
    term: [''],
    startDate: [],
    endDate: []
  });
  searchResults: SearchEdictResponse;
  displayedColumns = ['id', 'dates', 'match', 'actions'];
  constructor(private fb: FormBuilder,
    private certService: CertService) { }
  doSearch() {
    this.certService.searchEdicts(this.searchForm.value).subscribe(v => this.searchResults = v);
  }
}
